export default {
  myAccount: {
    myAccount: '我的帳戶',
    nickName: '昵稱',
    nickNamePlaceholder: '請輸入昵稱',
    birthdayPlaceholder: '請選擇日期',
    birthday: '生日',
    emailSubscribe: '您是否希望接收促銷資訊？',
    uid: '用戶唯一碼',
    nicknameValidFail: "昵稱不能包含特殊字符"
  },
  myOrder: {
    myOrder: '我的訂單',
    payEndTime: "付款期限 ",
    allOrder: '所有訂單',
    pendingPaymentOrder: '待支付',
    todoOrder: '待處理',
    shippedOrder: '待收貨',
    doneOrder: '已完成',
    orderDate: '下單時間',
    orderNo: '訂單編號',
    orderPayDate: '剩餘付款時間',
    orderCancel: '取消訂單',
    orderCancelSuccess: '取消成功',
    orderDetail: '訂單詳情',
    orderExpress: '查看配送進度',
    orderAllProduct: '全部商品',
    orderPayment: '付款方式',
    orderPayTips: '付款方式',
    orderPaymentTips: '請在 {date} 内完成付款。',
    orderPaymentNoPay: '付款超時',
    addressTitle: '收貨地址',
    addressUserName: '收貨人',
    address: '詳細地址',
    addressPost: '郵遞區號',
    addressTel: '聯繫電話',
    remarks: '訂單留言',
    productTitle: '商品信息',
    deliveryNum: '大約{num}個包裹',
    channelDate: '指定收貨時間',
    delivery: '運輸',
    noOrder: '暫無訂單記錄',
    orderExpressTitle: "物流資訊",
    cancelTips: "取消訂單後不可返回，是否繼續操作？",
    cancelBtn1: "確認取消",
    cancelBtn2: "我再想想",
    orderPointsTips: "訂單完成後可獲得積分",
    productTotal: "商品金額小計",
    expressFree: "運費",
    serviceFree: "貨到付款手續費",
    promotionFree: "促銷",
    couponFree: "優惠券",
    pointsFree: "點數抵扣",
    totalFree: "合計",
    productCode: '商品編號',
    productOptionName: '規格',
    productNum: '數量',
    productReturn: '退換商品',
    productReturnDetail: '查看退換詳情',
    alteration: '變更',
    package: '包裹',
    noExpressInfo: '無快遞信息',
    reBuy: "再次購買"
  },
  myCoupon: {
    myCoupon: '我的優惠券',
    derate: '{num} OFF',
    discount: '折扣',
    unconditional: '滿任意金額可以用',
    useCondition: '滿{money}可以用',
    usefulLife: '使用有效期：',
    freeTransport: '免運券',
    commodityCoverage: '商品範圍：',
    allProductUse: '全部商品',
    portionProductUse: '部分商品',
    portionProductCanNotUse: '部分商品不可用',
    freeTransportArea: '免運費區域：',
    allArea: '全部區域',
    except: '除外',
    immediateUse: '立即使用',
    usable: '可用',
    used: '已使用',
    overdue: '已過期',
    noCoupon: '暫無優惠券',
    getNow: '立即領取',
    limitGet: '限領：',
    unit: '張',
    couponUseTimePrompt1: '領券當日開始{time}天內',
    couponUseTimePrompt2: '領券次日開始{time}天內',
    freeTransportCoupon: '免運券',
    useCondition1: '满{num}',
    useCondition2: '可以用'
  },
  productEvaluationList: {
    productEvaluationList: '商品評價',
    predictPointPrompt: '評價後可獲得 <span class="predictPointPrompt">{point}</span> 積分',
    awardedPointPrompt: '已獲得 <span class="awardedPointPrompt">{point}</span> 積分',
    immediateEvaluation: '立即評價',
    orderDate: '下單時間',
    noEvaluation: '待評價',
    haveEvaluation: '已評價',
    noEvaluationPh: '暫無待評價商品',
    haveEvaluationPh: '暫無已評價商品',
    evaluationDetail: '評價詳情',
    productScore: '商品評分',
    yourEvaluation: '您的評價',
    pleaseInputYourEvaluation: '請輸入您的評價',
    pictureComment: '曬圖',
    uploadPicture: '上傳圖片',
    submitEvaluation: '提交評價',
    haveEvaluationPrompt: '您已評價，預計將獲得 <span class="haveEvaluationPrompt">{point}</span> 積分獎勵  ',
    evaluationDate: '評價時間',
    pictureNumPrompt: '共 <span class="pictureNumPrompt">{number1}</span> 張,還能上傳 <span class="pictureNumPrompt">{number2}</span> 張',
    allProductHaveEvaluation: '該訂單所有商品都已評價',
    star_null: '請選擇商品評分',
    evaluation_error: '評價內容必須在 5 至 200 字元之間'
  },
  myPoint: {
    myPoint: '我的點數',
    myPointTotal: '我的點數總數',
    aboutToExpirePointNumber: '本月底即將過期的點數',
    addDate: "獲得日期",
    incomingsOutgoings: '收入/支出',
    dueDate: "有效截止日期",
    explain: "說明"
  },
  productReturnList: {
    productReturnList: '商品退換貨',
    product: '商品',
    applicationDate: '申請時間',
    type: '類型',
    status: '狀態',
    returnedGoods: '退貨',
    exchangeGoods: '換貨',
    returnAmount: '退換數量',
    inProgress: '處理中',
    Processed: '已處理',
    orderInfo: '訂單內容',
    orderNo: '訂單編號',
    orderDate: '訂單日期',
    productInfoAndReason: '商品信息與退換貨原因',
    returnType: "退換類型",
    returnReason: "退換貨原因",
    returnReason1: '沒有收到商品',
    returnReason2: '發錯商品',
    returnReason3: '錯誤下單',
    returnReason4: '商品質量問題，賞味期限過期',
    returnReason5: '其他,請說明原因',
    productUnsealing: '商品已開封',
    remark: '備註',
    amount: '數量',
    returnPrompt: '提交表示您已閱讀並同意',
    shoppingTerms: '退換貨協議',
    productReturnApply: '退換貨申請',
    productReturnDetail: '退換貨詳情',
    applyReason: '申請原因',
    serviceAnswer: "客服答覆",
    submitSuccess: "提交成功"
  },
  addressManagement: {
    addressManagement: '我的收貨地址',
    addAddress: '新增地址',
    editAddress: '編輯地址',
    country: "國家",
    postcode: '郵遞區號',
    postcodePh: '請輸入郵遞區號',
    area: '地區',
    detailedAddress: '地址',
    consigneeName: '收貨人姓名',
    consigneeNamePh: '請輸入收貨人姓名',
    consigneeNameValidFail: '收貨人姓名不能輸入特殊字符',
    phone: '聯繫電話',
    phonePh: '請輸入聯系電話',
    phoneErr: '請輸入正確的聯系電話',
    operation: '操作',
    setDefault: '設為默認',
    defaultAddress: '默認地址',
    setDefaultaddAddress: '設為預設收貨地址',
    address1: '都道府縣',
    address2: '市区町村',
    address3: '詳細地址（丁目·番地·建物名·部屋·番號）',
    address3Ph: '請輸入詳細地址',
    address3w: '詳細地址中不能包含特殊字符',
    postcodeAutoMatch: '根據郵編自動匹配',
    deleteAddress: '刪除地址',
    deleteAddressPrompt: "確定要刪除嗎?",
    postcodeError: '邮编不存在',
    townPlaceholder: '請選擇市區町村',
    noAddress: '暫無收貨地址'
  },
  myCollect: {
    myCollect: '我的收藏',
    cancelCollect: '取消收藏'
  },
  memberCenter: {
    logout: '退出帳戶',
    memberCenter: '會員中心',
    editEmail: '編輯郵箱',
    editPhone: '編輯電話',
    updatePwd: '更新密碼',
    newPwd: '新密碼',
    newPwdNull: '請輸入新密碼',
    oldPwd: '原密碼',
    oldPwdNull: '請輸入原密碼',
    pleaseChangeEmail: '新郵箱地址與舊郵箱地址相同，無需修改',
    pleaseChangePhone: '新手機號碼與舊手機號碼相同，無需修改',
    logoutSuccess: '退出成功'
  }
};